// Resolve a stored image URL into an absolute URL the browser can fetch.
// Relative URLs (starting with /api/files/) get prefixed with REACT_APP_BACKEND_URL.
// Already-absolute URLs are returned as-is. Empty / null returns ''.
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImage = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return `${API_URL}${url}`;
  return url;
};
